module.exports = __webpack_public_path__ + "d308073b/img/splash-icon.07a7c465.svg";